import React from 'react';
import { ReactComponent as CheckIconSvg } from '@images/common/check-icon.svg';

export const CheckIcon = () => {
  return <CheckIconSvg id='check-icon-id' />;
};
